import React from 'react';
import './Summary.scss';

type SummaryProps = {
    summary: string;
};

export const Summary = ({ summary }: SummaryProps) => {
    return (
        <>
            {summary && (
                <p className="summary">
                    {/* Summary comes from the summary field in the creation flow */}
                    <strong
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: summary,
                        }}
                    ></strong>
                </p>
            )}
        </>
    );
};
